// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewUser_root__1IfFW"};